import React from 'react'
import { useLocation } from 'react-router-dom'

const GirlfriendIcon = () => {
  const location = useLocation()
  const isHalloween = !!location.pathname.includes('/halloween')
  return (
    <svg width='83' height='82' viewBox='0 0 83 82' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_dd_821_1821)'>
        <rect x='15.625' y='17' width='44' height='44' rx='10' fill={`${isHalloween ? 'url(#halloweenGradient)' : 'url(#paint0_linear_821_1821)'}`} />
        <g transform='translate(28, 28) scale(1.3)'>
          <path
            d='M10.9246 11.008C11.2752 11.008 11.6083 11.0781 11.9238 11.2184C11.5732 10.1665 10.8369 9.28999 9.87272 8.729C9.43444 8.76407 8.99617 8.7816 8.57543 8.7816H8.50531C7.80408 9.34258 7.01519 9.65814 6.24383 9.65814C5.49 9.65814 4.68359 9.34258 3.98235 8.7816H3.91223C3.49149 8.7816 3.07075 8.76407 2.61495 8.729C1.24754 9.51789 0.335938 10.9905 0.335938 12.6734V14.2687C0.335938 14.5317 0.546308 14.7596 0.826801 14.7596H8.89099C8.41766 14.0233 8.33 13.1117 8.73321 12.3404C9.17148 11.5164 9.99543 11.008 10.9246 11.008Z'
            fill='white'
          />
          <path
            d='M1.46008 7.64241C2.2665 7.76512 3.30082 7.87031 4.35267 7.83525C4.93119 8.3787 5.63242 8.71179 6.26353 8.71179C6.89464 8.71179 7.59587 8.3787 8.17439 7.83525C9.22624 7.87031 10.2606 7.76512 11.067 7.64241C11.365 7.58981 11.4176 7.20414 11.1546 7.06389C10.5411 6.74833 9.94501 6.06463 9.94501 4.67969C9.94501 0.349577 7.35044 -0.193879 6.26353 0.332047C5.17662 -0.176348 2.58205 0.349577 2.58205 4.67969C2.58205 6.08216 2.00354 6.74833 1.37243 7.06389C1.09193 7.20414 1.16206 7.58981 1.46008 7.64241ZM3.89687 4.36414C4.94872 4.29402 6.42131 3.75056 7.28032 2.7513C7.52575 3.32982 7.99908 3.80315 8.5776 4.04858C8.59513 4.29402 8.61266 4.55698 8.61266 4.855C8.61266 6.52043 7.17513 7.87031 6.246 7.87031C5.31686 7.87031 3.87934 6.52043 3.87934 4.855C3.89687 4.67969 3.89687 4.52192 3.89687 4.36414Z'
            fill='white'
          />
          <path
            d='M14.3436 12.095C13.7651 11.797 13.0638 11.9723 12.608 12.4281L12.31 12.7261L11.9769 12.3755C11.2932 11.6918 10.0836 11.8145 9.59273 12.7787C9.29471 13.3572 9.47001 14.0584 9.92581 14.5142L12.1172 16.7231C12.2224 16.8283 12.3977 16.8283 12.5028 16.7231L14.7468 14.4792C15.448 13.7955 15.3078 12.5858 14.3436 12.095Z'
            fill='white'
          />
        </g>
      </g>
      <defs>
        <filter id='filter0_dd_821_1821' x='0.625' y='0' width='82' height='82' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='0.4' />
          <feGaussianBlur stdDeviation='1.54375' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.854902 0 0 0 0 0.388235 0 0 0 0 0.564706 0 0 0 0.315 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_821_1821' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='9.5' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.854902 0 0 0 0 0.388235 0 0 0 0 0.564706 0 0 0 0.63 0' />
          <feBlend mode='normal' in2='effect1_dropShadow_821_1821' result='effect2_dropShadow_821_1821' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect2_dropShadow_821_1821' result='shape' />
        </filter>
        <linearGradient id='paint0_linear_821_1821' x1='23.5112' y1='17' x2='64.7525' y2='23.8168' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F76FAF' />
          <stop offset='1' stopColor='#FF6182' />
        </linearGradient>
      </defs>

      <defs>
        <linearGradient id='halloweenGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='#ED712B' />
          <stop offset='100%' stopColor='#D03C3C' />
        </linearGradient>

        <linearGradient id='defaultGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='#4ECDC4' />
          <stop offset='100%' stopColor='#556270' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GirlfriendIcon
